// FarmerOnboardingPage.duck.js

import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { storableError } from '../../util/errors';

// ================ Action types ================ //

export const UPDATE_FARMER_PROFILE_REQUEST =
  'app/FarmerOnboardingPage/UPDATE_FARMER_PROFILE_REQUEST';
export const UPDATE_FARMER_PROFILE_SUCCESS =
  'app/FarmerOnboardingPage/UPDATE_FARMER_PROFILE_SUCCESS';
export const UPDATE_FARMER_PROFILE_ERROR =
  'app/FarmerOnboardingPage/UPDATE_FARMER_PROFILE_ERROR';

// ================ Reducer ================ //
const initialState = {
  updateInProgress: false,
  updateError: null,
  updateSuccess: false,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_FARMER_PROFILE_REQUEST:
      return { ...state, updateInProgress: true, updateError: null };

    case UPDATE_FARMER_PROFILE_SUCCESS:
      return { ...state, updateInProgress: false, updateSuccess: true };

    case UPDATE_FARMER_PROFILE_ERROR:
      return { ...state, updateInProgress: false, updateError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const updateFarmerProfileRequest = () => ({
  type: UPDATE_FARMER_PROFILE_REQUEST,
});

export const updateFarmerProfileSuccess = () => ({
  type: UPDATE_FARMER_PROFILE_SUCCESS,
});

export const updateFarmerProfileError = e => ({
  type: UPDATE_FARMER_PROFILE_ERROR,
  error: true,
  payload: e,
});

// ================ Thunk ================ //

export const updateFarmerProfile = profileData => (dispatch, getState, sdk) => {
  dispatch(updateFarmerProfileRequest());

  const state = getState();
  const currentUser = state.user.currentUser;

  if (!currentUser || !currentUser.id) {
    const err = new Error("User not logged in");
    dispatch(updateFarmerProfileError(err));
    return Promise.reject(err);
  }

  const updatedPublicData = {
    ...currentUser.attributes.profile.publicData,
    farmerProfile: profileData,
    isFarmer: true,
  };

  return sdk.currentUser
    .updateProfile({
      publicData: updatedPublicData,
    })
    .then(response => {
      dispatch(addMarketplaceEntities(response));
      return dispatch(fetchCurrentUser()).then(() => {
        dispatch(updateFarmerProfileSuccess());
        return response;
      });
    })
    .catch(e => {
      dispatch(updateFarmerProfileError(storableError(e)));
      return e;
    });
};

export const loadData = () => {
  return Promise.resolve({});
};
